import React from 'react'
import { useLiveContext } from '../../../context/live.context'
import Badge from '../../core/Badge'
import SportIcon from '../SportIcon'

export const LiveSportFilter = () => {
  const liveContext = useLiveContext()

  const liveGames = liveContext.liveGames
  const sports = liveContext.sports
  const activeSportId = liveContext.liveListActiveSportId
  const setSportId = liveContext.setLiveListActiveSportId

  return (
    <div className="live-sport-filter flex flex-col space-y-4">
      <div className="live-sport-filter-sports flex flex-col space-y-2">
        {sports?.map((sport) => {
          const gameCount = liveGames?.filter((game) => game.sportId === sport.id)?.length

          return (
            <React.Fragment key={sport.id}>
              {gameCount > 0 && (
                <div
                  onClick={() => setSportId(sport.id)}
                  className={`live-sport-filter-sport flex flex-col rounded-md border-[1px] border-neutral cursor-pointer transition ${
                    sport.id === activeSportId
                      ? 'live-sport-filter-sport-active bg-primary text-primaryContrast'
                      : 'bg-gray-500 bg-opacity-10 hover:bg-opacity-20'
                  }`}
                >
                  <div className="live-sport-filter-sport-inner flex justify-between items-center p-2">
                    <div className="live-sport-filter-sport-content flex items-center justify-between w-full">
                      <div className="live-sport-filter-sport-name flex flex-grow space-x-2 items-center text-xs">
                        <div className="live-sport-filter-sport-name-icon text-xl bg-gray-500 bg-opacity-10 p-1 rounded-full">
                          <SportIcon sportShortSign={sport.shortSign} />
                        </div>
                        <span className="live-sport-filter-sport-name-label">{sport.name}</span>
                      </div>

                      <div className="live-sport-filter-sport-info flex items-center">
                        <Badge
                          value={liveGames?.filter((game) => game.sportId === sport.id)?.length}
                          className="live-sport-filter-sport-info-badge !text-xxs"
                          backgroundColor={
                            sport.id === activeSportId ? 'bg-primaryContrast' : 'bg-gray-500 bg-opacity-10'
                          }
                          textColor={sport.id === activeSportId ? 'text-primary' : 'text-slbCategoryItemContrast'}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </React.Fragment>
          )
        })}
      </div>
    </div>
  )
}
